/* unplugin-vue-components disabled */import script from "./AppgProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppgProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./AppgProgressBar.vue?vue&type=style&index=0&id=547c4667&scoped=true&lang=scss"

import exportComponent from "../../../../../../unionglobal-store-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547c4667"]])

export default __exports__